module.exports = __webpack_public_path__ + "img/BAAC.e6074945.png";